import { useCallback } from "react";
import { useFolderTree } from "../../contexts/folderTree.js";
function useFolderTreeSortMode({ buttonId = "sort" } = {}) {
    const { set } = useFolderTree();
    const handleSortNode = useCallback((shToolbarActiveButton)=>{
        set({
            isCreatableLinkDisabled: !!shToolbarActiveButton,
            toolbarActiveButton: shToolbarActiveButton,
            isSortableDisabled: !shToolbarActiveButton
        });
    }, [
        set
    ]);
    const handleSortClick = useCallback(()=>handleSortNode(buttonId), [
        buttonId,
        handleSortNode
    ]);
    const handleSortCancel = useCallback(()=>handleSortNode(), [
        handleSortNode
    ]);
    return {
        handleSortClick,
        handleSortCancel
    };
}
export { useFolderTreeSortMode };
